var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.137 2.314a.7.7 0 0 0-.274 1.372l.274-1.372Zm.912.896-.137.686.137-.686Zm17.114 10.639-.68-.17.68.17Zm1.122-4.491-.679-.17.68.17ZM4.647 4.972l-.696.07.696-.07ZM4.8 6.5l-.697.07.002.013L4.8 6.5Zm.989 8.238.695-.083-.695.083ZM8.5 5.8a.7.7 0 1 0 0 1.4V5.8ZM1.863 3.686l1.05.21.274-1.373-1.05-.21-.274 1.373ZM7.774 17.2h8.993v-1.4H7.774v1.4Zm13.068-3.181 1.123-4.491-1.359-.34-1.122 4.491 1.358.34ZM3.95 5.042l.152 1.528 1.394-.14-.153-1.528-1.393.14Zm.154 1.541.989 8.239 1.39-.167-.989-8.238-1.39.166Zm14.95-.783H13.4v1.4h5.654V5.8Zm-5.655 0H8.5v1.4h4.9V5.8Zm8.565 3.728a3 3 0 0 0-2.91-3.728v1.4a1.6 1.6 0 0 1 1.551 1.988l1.359.34ZM16.767 17.2a4.2 4.2 0 0 0 4.075-3.181l-1.358-.34a2.8 2.8 0 0 1-2.717 2.121v1.4Zm-8.993-1.4a1.3 1.3 0 0 1-1.29-1.145l-1.39.167a2.7 2.7 0 0 0 2.68 2.378v-1.4ZM2.912 3.896a1.3 1.3 0 0 1 1.039 1.146l1.393-.14a2.7 2.7 0 0 0-2.157-2.379l-.275 1.373Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 20.25,
    r: 1.25,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 20.25,
    r: 1.25,
    fill: "#fff"
  })));
};
export default SvgCart;